// ---------------------------------------------------------
// #########################################################
//    Velstar Custom JS
// #########################################################
// ---------------------------------------------------------

// Reputon Google Reviews - link override
// The widget injects <a> tags after page load with no callback, so we use a
// MutationObserver scoped to the widget container to catch them as they appear.
const initReputonLinkOverride = () => {
  const overrideUrl = window.theme && window.theme.reputonReviewsLinkOverride;
  if (!overrideUrl) return;

  const overrideLinks = (container) => {
    container.querySelectorAll('a').forEach((link) => {
      link.href = overrideUrl;
    });
  };

  const widgets = document.querySelectorAll('.reputon-google-reviews-widget');
  if (!widgets.length) return;

  const widgetObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const links = node.tagName === 'A' ? [node] : Array.from(node.querySelectorAll('a'));
        links.forEach((link) => {
          link.href = overrideUrl;
        });
      });
    });
  });

  widgets.forEach((widget) => {
    widgetObserver.observe(widget, { childList: true, subtree: true });
  });
};

initReputonLinkOverride();
